import { Default } from '@crochik/pi-react/context';

import { AppointmentFormState } from '../AppointmentForm';
import * as api from '@crochik/schedulerapi.ts';
import App from '@crochik/pi-react/application/App';
import API from '../services/API';

export default function AddAppointment() {

    const form: AppointmentFormState = Default.state.get('Appointment', 'form');
    const { start, end } = form;
    const request: api.AppointmentReq = {
        start,
        end,
    };

    API().createAppointment(request)
        .then(appt => {
            App().selectPage('Confirmation', 'Submit', appt);
        })
        .catch(e => {
            alert('Error adding appointment');
        });
}



// WEBPACK FOOTER //
// ./src/app/actions/Submit.ts